import { useEffect, useState } from "react";
import { useApi } from "./useApi";

// An <img src> sends no Authorization header, so an attached photo's bytes come through useApi
// and live as an object URL for as long as the row shows that attachment.
export function useAttachmentUrl(draftId: number, storageKey: string | null): string | null {
  const { getBlob } = useApi();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!storageKey) {
      setUrl(null);
      return undefined;
    }
    let dropped = false;
    let objectUrl: string | null = null;
    getBlob(`/api/evidence-drafts/${draftId}/attachments/file?key=${encodeURIComponent(storageKey)}`, { slowApi: true })
      .then((blob) => {
        if (dropped) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => { if (!dropped) setUrl(null); });
    return () => {
      dropped = true;
      setUrl(null);
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [getBlob, draftId, storageKey]);

  return url;
}
